<template>
  <div
    class="flex min-w-0 items-center text-sm font-bold text-muted-foreground"
  >
    <template v-for="(item, idx) in crumbs" :key="idx">
      <ChevronDownIcon
        v-if="idx !== 0"
        class="-mx-1 size-4 shrink-0 -rotate-90"
      />

      <span
        v-if="pending && idx === crumbs.length - 1"
        class="mx-2 h-5 w-20 animate-pulse rounded-md bg-muted-foreground"
      >
      </span>
      <RouterLink
        v-else-if="item.from"
        :to="item.from"
        :aria-label="item.title"
        :class="[
          `flex min-w-0 items-center gap-3 rounded-full px-2 py-[0.3125rem] outline-2 outline-action transition hover:bg-gray-200 hover:text-black focus-visible:outline active:bg-gray-200 dark:hover:bg-card dark:hover:text-white dark:active:bg-card dark:active:text-white`,
          idx === crumbs.length - 1
            ? `font-bold text-black dark:text-white`
            : `text-inherit`,
        ]"
      >
        <div
          v-if="item.image"
          class="size-4 shrink-0 overflow-hidden rounded-md"
        >
          <img :src="item.image" class="size-full object-cover" />
        </div>
        <component
          :is="iconMappingMicro[item.icon]"
          v-else-if="typeof item.icon === 'string'"
          class="size-4 shrink-0 text-purple-500"
        />
        <component
          :is="item.icon"
          v-else-if="item.icon"
          class="size-4 shrink-0 text-purple-500"
        />

        <span class="truncate">
          {{ truncateRight(item.title, 90) }}
        </span>
      </RouterLink>
      <span
        v-else
        :role="idx === crumbs.length - 1 ? 'heading' : undefined"
        :aria-level="idx === crumbs.length - 1 ? 1 : undefined"
        :aria-label="item.title"
        :class="[
          `flex min-w-0 items-center gap-3 px-2 transition`,
          idx === crumbs.length - 1
            ? `font-bold text-black dark:text-white`
            : `shrink-0 text-inherit`,
        ]"
      >
        <div
          v-if="item.image"
          class="size-4 shrink-0 overflow-hidden rounded-md"
        >
          <img :src="item.image" class="size-full object-cover" />
        </div>
        <component
          :is="iconMappingMicro[item.icon]"
          v-else-if="typeof item.icon === 'string'"
          class="size-4 shrink-0 text-purple-500"
        />
        <component
          :is="item.icon"
          v-else-if="item.icon"
          class="size-4 shrink-0 text-purple-500"
        />

        <span class="truncate">
          {{ truncateRight(item.title, 90) }}
        </span>
      </span>
    </template>
  </div>
</template>

<script setup lang="ts">
import ChevronDownIcon from "@/icons/heroicons/chevron-down-micro.svg";
import { iconMappingMicro } from "@/icons/icon-mapping-micro";
import { truncateRight } from "@/lib/strings";

import type { BreadcrumbPath } from "./breadcrumb-types";

defineProps<{
  crumbs: BreadcrumbPath;
  pending?: boolean;
}>();
</script>
